import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import * as types from '@/main/store/RequestFormat/requestFormatTypes';

// Api's
import { RequestFormatApi } from '@/main/api/requestFormatApi';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* fetchPayloadFormat(action: any) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      new RequestFormatApi().getDomain,
      action.payload
    );
    yield put({
      type: types.GET_PAYLOAD_FORMAT_SUCCESS,
      payload: response.data.result,
    });
  } catch (error) {
    yield put({
      type: types.GET_PAYLOAD_FORMAT_FAILURE,
      error,
    });
  }
}

export function* requestFormatSagaWatcher() {
  yield takeLatest(types.GET_PAYLOAD_FORMAT, fetchPayloadFormat);
}
